<template>
    <div class="product_item_content_media" :data-indicador="indicador" :id="'product_item_content_media_'+indicador">
        <div class="product_gallery_slider" :data-indicador="indicador" :id="'product_gallery_slider'+indicador">
            <ul :data-indicador="indicador" v-if="gallery && gallery.length>0" :id="'product_gallery_slider_list_'+indicador">
                <li v-for="(g, gIdx) in gallery" :key="gIdx"
                    :id="'gellery_'+indicador+'_item_'+g.id"
                    :class="['gellery_'+indicador+'_items', (itemId==g.id) ? 'active' : '']"
                    :data-indicador="indicador"
                    :data-itemg="g.id">
                    <span class="gallery_item_index">{{ gIdx + 1 }} / {{ gallery.length }}</span>
                    <img v-if="g.type_file=='img'" class="product_item_img" :src="urlMedia+'/img/'+g.name_file" alt="" :data-indicador="indicador">
                    <video v-else :src="urlMedia+'/video/'+g.name_file" controls muted loop preload="auto" :poster="urlMedia+'/video/'+g.name_file+'.jpg'" class="product_item_video" :data-indicador="indicador"></video>
                </li>
            </ul>
            <ul v-else>
                <li class="slide_default" :data-indicador="indicador" @click.prevent="$emit('editGallery', {name: 'productUpload', data: {productItem, urlMedia}})">
                    <i class="fas fa-photo-video icon_default"></i>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: ['productItem', 'indicador', 'gallery', 'urlMedia'],
    data(){
        return {
            itemId: null,
        };
    },
    watch: {
        gallery(){
            this.itemId = (this.gallery && this.gallery.length > 0) ? this.gallery[0].id : 0;
        }
    },
    mounted(){
        this.itemId = (this.gallery && this.gallery.length > 0) ? this.gallery[0].id : 0;
    },
    methods: {
        indicadorSlider(ids){
            this.itemId = ids;
            this.$emit('clickNav', {SliderId: ids, indicador: this.indicador});
        },
    }
}
</script>
<style lang="scss" scoped>

.product_gallery_slider ul li {
    position: relative;
    .gallery_item_index {
        position: absolute;
        left: 10px;
        top: 10px;
        background: rgba(255, 255, 255, 0.5);
        padding: 2px 20px;
        border-radius: 20px;
        box-shadow: 1px 1px 5px rgb(0 0 0 / 15%);
        opacity: 0.8;
    }
}
</style>

